// CSV the way Excel opens it: UTF-8 with a BOM, semicolons between cells,
// every cell quoted (so semicolons, quotes and newlines inside stay put).

export const CSV_SEPARATOR = ';';

// Excel opens UTF-8 CSVs correctly when a BOM is present.
export const UTF8_BOM = '﻿';

export function csvEscape(value: unknown): string {
    if (value === null || value === undefined) return '""';
    return `"${String(value).replace(/"/g, '""')}"`;
}

export function csvLine(cells: unknown[]): string {
    return cells.map(csvEscape).join(CSV_SEPARATOR);
}

// Hands the browser a file to save. Not unit-tested: it only touches the DOM.
export function downloadCsv(filename: string, csv: string): void {
    const blob = new Blob([UTF8_BOM + csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}
